import React from "react";
import { array, func } from "prop-types";

import { Icon } from "../../atoms/icon";
import "./filter-pills.m.css";

export const FilterPills = ({
  selectedCities = [],
  onRemoveFilter,
  ...props
}) => {
  if (selectedCities.length === 0) {
    return null;
  }

  return (
    <div styleName="filter-pills" {...props}>
      {selectedCities.map((city) => (
        <div key={city} styleName="filter-pill">
          <span styleName="pill-text">{city}</span>
          <button
            type="button"
            styleName="pill-remove"
            onClick={() => onRemoveFilter && onRemoveFilter(city)}
            aria-label={`Remove ${city} filter`}
          >
            <Icon name="close" size="xsmall" />
          </button>
        </div>
      ))}
    </div>
  );
};

FilterPills.propTypes = {
  selectedCities: array,
  onRemoveFilter: func
};